import { useState, useEffect } from 'react';

/**
 * Hook that tracks responsive breakpoints to determine how many column priority
 * levels are visible (1 on mobile, 2 on tablet, 3 on desktop).
 * @returns {number} max visible priority level
 */
export function useDataTableResponsivePriority() {
	const [maxVisiblePriority, setMaxVisiblePriority] = useState(3);
	useEffect(() => {
		const check = () => {
			if (window.matchMedia('(max-width: 480px)').matches) {
				setMaxVisiblePriority(1);
			} else if (window.matchMedia('(max-width: 768px)').matches) {
				setMaxVisiblePriority(2);
			} else {
				setMaxVisiblePriority(3);
			}
		};
		check();
		const mq480 = window.matchMedia('(max-width: 480px)');
		const mq768 = window.matchMedia('(max-width: 768px)');
		mq480.addEventListener('change', check);
		mq768.addEventListener('change', check);
		return () => {
			mq480.removeEventListener('change', check);
			mq768.removeEventListener('change', check);
		};
	}, []);
	return maxVisiblePriority;
}
